import { render, staticRenderFns } from "./securityCard.vue?vue&type=template&id=66ca64b8&scoped=true"
import script from "./securityCard.vue?vue&type=script&lang=js"
export * from "./securityCard.vue?vue&type=script&lang=js"
import style0 from "./securityCard.vue?vue&type=style&index=0&id=66ca64b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca64b8",
  null
  
)

export default component.exports